import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={cn('bg-white border border-gray-200 rounded-xl shadow-sm dark:bg-gray-900 dark:border-gray-800', className)}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...rest }: CardProps) {
  return (
    <div {...rest} className={cn('px-6 py-4 border-b border-gray-100 dark:border-gray-800', className)}>
      {children}
    </div>
  );
}

export function CardBody({ className, children, ...rest }: CardProps) {
  return (
    <div {...rest} className={cn('p-6', className)}>
      {children}
    </div>
  );
}

export function CardFooter({ className, children, ...rest }: CardProps) {
  return (
    <div {...rest} className={cn('px-6 py-4 border-t border-gray-100 bg-gray-50/50 rounded-b-xl dark:border-gray-800 dark:bg-gray-800/30', className)}>
      {children}
    </div>
  );
}
